<template>
  <v-dialog v-if="opened" v-model="opened" max-width="600" persistent>
    <v-form ref="formMemberReferral" v-model="valid" @submit.prevent="save()">
      <v-card :loading="loadingData" :disabled="loadingData">
        <v-card-title class="h-100">
          <div class="d-flex align-items-center">
            {{ !id ? " Tambah" : "Ubah" }}
            <v-btn icon @click="close()" class="ml-auto">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row justify="center" no-gutters>
              <v-col cols="12" md="10">
                <v-autocomplete
                  :loading="isLoadingZone"
                  :items="listMembers"
                  item-text="name"
                  item-value="id"
                  label="Pilih Member yang di refer"
                  dense
                  outlined
                  :search-input.sync="search"
                  v-model="data.referred_member_id"
                  :rules="[(v) => !!v || 'Member yang di refer harus diisi']"
                  @update:search-input="getRoles()"
                ></v-autocomplete>

                <v-text-field
                  label="Free Bulan"
                  dense
                  outlined
                  v-model="data.free_month"
                  @keypress="isNumber($event)"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-row no-gutters>
            <v-col cols="12" class="d-flex justify-end">
              <v-btn
                depressed
                class="ma-1"
                :disabled="loading"
                @click="close()"
              >
                <v-icon small left>mdi-close</v-icon>
                Tutup
              </v-btn>
              <v-btn
                type="submit"
                color="success"
                depressed
                class="ma-1"
                :loading="loading"
                :disabled="loading"
                @click.prevent="save()"
              >
                <v-icon small left>mdi-content-save</v-icon>
                Simpan
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import ApiService from "@/core/services/api.service";

import { isNumber } from "@/core/utils";

export default {
  data() {
    return {
      action: "create",
      id: null,
      opened: false,
      loading: false,
      loadingData: false,
      valid: true,
      listZone: [],
      isLoadingZone: false,
      listMembers: [],
      dataReference: null,
      search: "",
      data: {
        member_id: null,
        referred_member_id: null,
        free_month: 0,
      },
    };
  },
  props: {
    success: {
      type: Function,
      default: function () {},
    },
  },
  async mounted() {
    this.listMembers = (
      await ApiService.get("user/list?role_slug=member")
    ).data;
  },
  methods: {
    open(userId, id) {
      if (!userId) {
        return;
      }
      this.data.user_id = userId;
      this.opened = true;
      setTimeout(() => {
        this.$refs.formMemberReferral.reset();
        if (id) {
          this.getData(id);
        }
      }, 1);
    },
    async getData(id) {
      this.loadingData = true;
      ApiService.get("member-referral?id=" + id)
        .then(({ data }) => {
          this.data = {
            user_id: data.member_id,
            referred_member_id: data.referred_member_id,
            free_month: data.free_month || 0,
          };
          this.id = id;
          this.loadingData = false;
        })
        .catch(({ response }) => {
          if (response.data) {
            this.handleError(response.data);
          }
          this.loadingData = false;
        });
    },
    async save() {
      this.$refs.formMemberReferral.validate();
      if (this.valid) {
        this.loading = true;
        this.data.member_id = this.data.user_id;
        const action = !this.id ? "post" : "update";
        let url = "member-referral";
        if (this.id) {
          url = url + "?id=" + this.id;
        }
        ApiService[action](url, this.data)
          .then(({ data }) => {
            if (data.id) {
              this.loading = false;
              this.success(data);
              this.$swal.fire({
                icon: "success",
                title: "Berhasil",
                text: "Data berhasil disimpan",
                showConfirmButton: false,
                timer: 3000,
              });
              this.close();
            }
          })
          .catch(({ response }) => {
            if (response.data) {
              this.handleError(response.data);
            }

            this.loading = false;
          });
      }
    },
    handleError(data) {
      if (data.error) {
        this.$swal.fire({
          icon: "warning",
          title: "Terjadi kesalahan",
          text: data.error,
          showConfirmButton: true,
          timer: 5000,
        });
      }
    },
    close() {
      this.opened = false;
      this.id = null;
      this.data.user_id = null;
      (this.listZone = []), (this.isLoadingZone = false);
      this.search = "";
      this.$refs.formMemberReferral.reset();
    },
    isNumber,
  },
  watch: {},
};
</script>
